export const tomos = [
  {
    number: 1,
    title: 'Nivel Inicial — Parte 1',
    weeks: 'Semanas 1 a 11',
    description:
      'El primer contacto con el stretching. Ejercicios base, respiración y confianza desde cero. Sin experiencia previa.',
  },
  {
    number: 2,
    title: 'Nivel Inicial — Parte 2',
    weeks: 'Semanas 12 a 26',
    description:
      'Consolidación de la técnica base. Cadenas musculares completas y primeras secuencias integradas.',
  },
  {
    number: 3,
    title: 'Nivel Intermedio — Parte 1',
    weeks: 'Semanas 1 a 26',
    description:
      'Técnicas PNF, elongación dinámica y trabajo de propiocepción. El alumno empieza a sentir resultados reales.',
  },
  {
    number: 4,
    title: 'Nivel Intermedio — Parte 2',
    weeks: 'Semanas 27 a 52',
    description:
      'Profundización técnica. Secuencias fluidas y trabajo de fuerza activa integrado al estiramiento.',
  },
  {
    number: 5,
    title: 'Nivel Avanzado — Parte 1',
    weeks: 'Semanas 1 a 26',
    description:
      'Rangos extremos, control excéntrico y trabajo de alta demanda física. Para el alumno que ya tiene base sólida.',
  },
  {
    number: 6,
    title: 'Nivel Avanzado — Parte 2',
    weeks: 'Semanas 27 a 52',
    description:
      'Split completo, movilidad de cadera 360° y secuencias de alta complejidad. El nivel élite del stretching.',
  },
  {
    number: 7,
    title: 'Adultos Mayores — Parte 1',
    weeks: 'Semanas 1 a 26',
    description:
      'Stretching adaptado para cuerpos maduros. Movilidad funcional, equilibrio y calidad de vida desde la silla.',
  },
  {
    number: 8,
    title: 'Adultos Mayores — Parte 2',
    weeks: 'Semanas 27 a 52',
    description:
      'Progresión segura para el adulto mayor. Autonomía, prevención de caídas y bienestar articular profundo.',
  },
  {
    number: 9,
    title: 'Restaurativo y Terapéutico — Parte 1',
    weeks: '',
    description:
      'Secuencias para alumnos con dolor crónico, lesiones activas y condiciones sistémicas. El stretching que cuida la salud de verdad.',
  },
  {
    number: 10,
    title: 'Restaurativo y Terapéutico — Parte 2',
    weeks: '',
    description:
      'Abordaje integral para condiciones como fibromialgia, artritis y osteoporosis. Trabajo de alta especificidad clínica.',
  },
  {
    number: 11,
    title: 'Relax y Miofascial — Parte 1',
    weeks: 'Semanas 1 a 26',
    description:
      'Rodillo de foam, técnicas Yin y liberación miofascial profunda. La clase que todos los alumnos necesitan pero nadie les da.',
  },
  {
    number: 12,
    title: 'Relax y Miofascial — Parte 2',
    weeks: 'Semanas 27 a 52',
    description:
      'Yoga Nidra, TRE y neurorregulación avanzada. El sistema nervioso de tu alumno nunca más va a ser el mismo.',
  },
]

export const bonuses = [
  {
    id: 1,
    icon: '📋',
    title: 'El Planner de Sesiones 360',
    description:
      'Plantillas de planificación diaria, semanal y mensual listas para imprimir. Nunca más improvises qué dar el lunes a la mañana.',
  },
  {
    id: 2,
    icon: '🗣️',
    title: 'El Arte de los Cues',
    description:
      '100+ frases sensoriales e imaginarias organizadas por zona corporal. Corregí a tus alumnos sin tocarlos y sin repetir siempre lo mismo.',
  },
  {
    id: 3,
    icon: '⚡',
    title: 'STRETCHING Express 20 Minutos',
    description:
      '8 clases completas de 20 minutos para el alumno que dice que no tiene tiempo. Sin equipamiento. Listo para usar mañana.',
  },
  {
    id: 4,
    icon: '🛡️',
    title: 'Checklist de Seguridad y Lesiones',
    description:
      'Guía rápida de decisión clínica. Semáforo de dolor, patologías frecuentes y protocolo de derivación para no cometer errores con la salud de tus alumnos.',
  },
  {
    id: 5,
    icon: '🦴',
    title: 'Anatomía Aplicada',
    description:
      'Mapa muscular de las 20 posturas más usadas. Qué músculo estirás, qué músculo activás y cómo prevenir lesiones en cada ejercicio.',
  },
  {
    id: 6,
    icon: '🎵',
    title: 'Cancionero & Guía de Sonido',
    description:
      'Playlists y música para cada momento de tu clase. Reset, Load, Peak, Flow y Nidra. Por nivel y por momento del día.',
  },
]

export const testimonialsIntro = [
  {
    initials: 'MP',
    name: 'María P.',
    city: 'Buenos Aires',
    role: 'Instructora de Stretching en Estudio Propio',
    quote:
      'Organicé todo el mes en una tarde. Nunca más llego a clase sin saber qué dar ni con quién.',
  },
  {
    initials: 'CG',
    name: 'Claudia G.',
    city: 'Córdoba',
    role: 'Instructora de Stretching en Academia Privada',
    quote:
      'Mis alumnos de nivel inicial mejoraron su movilidad desde la primera semana con el Tomo 1.',
  },
  {
    initials: 'FR',
    name: 'Federico R.',
    city: 'Rosario',
    role: 'Instructor de Stretching Independiente',
    quote:
      'Antes tardaba 1 hora armando una clase. Ahora son 5 minutos. Abro el tomo y dicto.',
  },
]

export const testimonialsFull = [
  {
    initials: 'MP',
    name: 'María P.',
    city: 'Buenos Aires',
    quote:
      'Compré un sábado. El domingo a la noche tenía el mes de clases completamente listo. Nunca más improviso.',
  },
  {
    initials: 'CG',
    name: 'Claudia G.',
    city: 'Córdoba',
    quote:
      'Tres alumnos de inicial que estaban estancados mejoraron su movilidad en el primer mes con el Tomo 1. Ahora renuevan sin que se los pida.',
  },
  {
    initials: 'FR',
    name: 'Federico R.',
    city: 'Rosario',
    quote:
      'Antes tardaba 1 hora armando una clase. Ahora son 5 minutos. Abro el tomo, veo la ficha y dicto. Así de simple.',
  },
  {
    initials: 'SV',
    name: 'Sofía V.',
    city: 'Mendoza',
    quote:
      'El Bonus de Anatomía cambió cómo corrijo a mis alumnos. Ahora sé exactamente qué músculo trabaja en cada ejercicio y lo puedo explicar.',
  },
  {
    initials: 'DA',
    name: 'Diego A.',
    city: 'Santa Fe',
    quote:
      'Stretching Seguro 360 me salvó con un alumno con hernia lumbar. Supe exactamente qué hacer y qué evitar. Eso no tiene precio.',
  },
  {
    initials: 'CR',
    name: 'Carolina R.',
    city: 'Tucumán',
    quote:
      'El Ebook de Mujer y Maternidad me permitió recibir alumnas embarazadas que antes derivaba a otros. Ahora cobro un 40% más por esas clases.',
  },
  {
    initials: 'LM',
    name: 'Laura M.',
    city: 'La Plata',
    quote:
      'El Planner de Sesiones me cambió la cabeza. Ahora planifico el mes entero en una tarde del domingo. Mis clases tienen más calidad y mis alumnos lo notan.',
  },
  {
    initials: 'MR',
    name: 'Martín R.',
    city: 'CABA',
    quote:
      'Tenía miedo de los adultos mayores. Con los Tomos 7 y 8 supe exactamente cómo progresar con ellos semana a semana. Hoy es mi grupo más fiel y el que mejor me paga.',
  },
]

export const faqs = [
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Inmediatamente después del pago recibís un email con el enlace de descarga. Todo en PDF, listo para guardar en tu teléfono, tablet o computadora. Sin apps. Sin suscripciones. Tuyo para siempre.',
  },
  {
    question: '¿Sirve si soy instructor nuevo o si tengo experiencia?',
    answer:
      'Sirve para los dos. Si sos nuevo, el sistema te da la estructura que necesitás para empezar con confianza. Si tenés experiencia, te ahorra horas de planificación y te da herramientas que probablemente no tengas.',
  },
  {
    question: '¿Los 6 Bonus están en las dos opciones?',
    answer:
      'Sí. Los 6 Bonus estratégicos están incluidos en el Pack Profesional y en el Megapack Élite. La diferencia del Megapack son los 2 Ebooks Élite adicionales.',
  },
  {
    question: '¿Qué diferencia hay con otros materiales que ya existen?',
    answer:
      'Stretching 360 es el único sistema diseñado específicamente para instructores de stretching argentinos. No son ejercicios sueltos ni tutoriales: es un sistema de 52 semanas por nivel, con fichas graficadas, progresión real y protocolos clínicos para casos complejos.',
  },
  {
    question: '¿Sirve para grupos con niveles mezclados?',
    answer:
      'Sí. Al tener materiales para cada nivel (inicial, intermedio, avanzado, adultos mayores, restaurativo y relax/miofascial) podés adaptar el contenido de cada tomo según la composición real de tu grupo.',
  },
  {
    question: '¿Qué pasa si no me sirve?',
    answer:
      'Tenés 7 días de garantía total. Si no es lo que esperabas, escribinos y te devolvemos el 100% del dinero. Sin preguntas. Sin formularios.',
  },
  {
    question:
      '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
    answer:
      'Sí, especialmente por los 2 Ebooks Élite. Stretching Seguro 360 te da los protocolos para los casos médicos complejos que hoy te generan miedo o que directamente rechazás. Y el Ebook de Mujer y Maternidad te abre el nicho de mayor rentabilidad del mercado: instructores especializados en embarazo y postparto cobran entre un 30 y un 50% más que los generalistas.',
  },
  {
    question: '¿Puedo pagar con tarjeta de crédito?',
    answer:
      'Sí. Aceptamos todas las tarjetas de crédito y débito, y transferencia bancaria. El pago se procesa de forma segura a través de Mercado Pago.',
  },
]

export const argentineCities = [
  'Buenos Aires',
  'Córdoba',
  'Rosario',
  'Mendoza',
  'Santa Fe',
  'Tucumán',
  'La Plata',
  'Mar del Plata',
  'Salta',
  'Neuquén',
  'San Juan',
  'Resistencia',
  'Corrientes',
  'Posadas',
  'Bahía Blanca',
  'Paraná',
  'San Miguel de Tucumán',
  'CABA',
  'Quilmes',
  'Lanús',
]

export const argentineNames = [
  'María',
  'Juan',
  'Ana',
  'Carlos',
  'Laura',
  'Diego',
  'Sofía',
  'Martín',
  'Carolina',
  'Federico',
  'Claudia',
  'Sebastián',
  'Gabriela',
  'Pablo',
  'Valeria',
  'Alejandro',
  'Natalia',
  'Rodrigo',
  'Florencia',
  'Matías',
  'Luciana',
  'Facundo',
  'Romina',
  'Nicolás',
  'Daniela',
  'Ezequiel',
]
